import {FACTOR_DATA, FACTOR_SETTING} from "Stores/actionTypes";
import FactorService from "Services/http/endpoints/factor/FactorService";
import StatusHandler from "Helpers/StatusHandler";

export const getFactorUnitList = (params) => {
  return async (dispatch) => {
    try {
      const response = await FactorService.getUnitListWithImg(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const factorData = response.data.Value;
        dispatch({
          type: FACTOR_DATA,
          factorData: factorData,
          factorPagination: response.data.Pagination,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const setFactorSetting = (factorSetting) => {
  return {
    type: FACTOR_SETTING,
    factorSetting : factorSetting
  }
}
